export const doorShoeColors = [
  {
    id: 1,
    type: "doorShoeColor",
    isNew: false,
    label: "Bronze",
  },
  {
    id: 2,
    type: "doorShoeColor",
    isNew: false,
    label: "Clear Anodized",
  },
  {
    id: 3,
    type: "doorShoeColor",
    isNew: false,
    label: "White",
  },
];